
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.902 4.512a1.038 1.038 0 00-.682.409L8.13 10.454 6.325 8.366A1.038 1.038 0 004.86 8.26a1.038 1.038 0 00-.108 1.467l2.653 3.068a1.038 1.038 0 001.622-.062l4.862-6.577a1.038 1.038 0 00-.216-1.451 1.038 1.038 0 00-.771-.193z"}}),_c('path',{attrs:{"d":"M1.126 0A1.14 1.14 0 000 1.126v15.748C0 17.484.515 18 1.126 18h15.748c.61 0 1.126-.515 1.126-1.126V1.126A1.14 1.14 0 0016.874 0zm.95 2.077h13.847v13.846H2.077z"}})])
          )
        }
      }
    